module.exports = __webpack_public_path__ + "img/running-costs-icon.de4fe3a1.svg";